var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popit-prize"},[_c('img',{attrs:{"src":require("@/assets/svg/prize.svg")}}),_c('p',{staticClass:"text"},[_vm._v("ура! подарок!")])])
}]

export { render, staticRenderFns }